module.exports = __webpack_public_path__ + "img/424.b59d933a.jpg";